import React, { MutableRefObject } from 'react';

import Player from 'video.js/dist/types/player';

import VideoJSPlayer from '../../../VideoJSPlayer';
import { PLAYBACK_RATES } from '../../../../constants/videoPlayerSettings';
import { useVideoRetry } from '../../../../hooks/useVideoRetry';

interface IOwnProps {
    videoSrc: string;
    videoRef: MutableRefObject<HTMLVideoElement | null>;
    playerRef: MutableRefObject<Player | null>;
    handleError: () => void;
    handleOrientation: (vertical: boolean) => void;
    type: string;
}

const SinglePlayer = ({
    videoSrc,
    videoRef,
    playerRef,
    handleError,
    type,
    handleOrientation,
}: IOwnProps) => {
    const { handleRetryOnSrcError } = useVideoRetry({
        playerRef,
        videoSrc,
        onFail: handleError,
        type,
    });
    const videoJsOptions = {
        autoplay: 'muted',
        playbackRates: PLAYBACK_RATES,
        controlBar: {
            liveDisplay: false,
            seekToLive: false,
            skipButtons: {
                backward: 10,
                forward: 10,
            },
        },
        plugins: {
            hotkeys: {
                seekStep: 10,
                enableModifiersForNumbers: false,
            },
        },
        controls: true,
        sources: [
            {
                src: videoSrc,
                type,
            },
        ],
        fluid: true,
    };

    return (
        <VideoJSPlayer
            options={videoJsOptions}
            videoRef={videoRef}
            playerRef={playerRef}
            handleError={handleError}
            handleSrcError={handleRetryOnSrcError}
            handleOrientation={handleOrientation}
        />
    );
};

export default SinglePlayer;
